import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';


export const IncrementDecrementCounter = styled.div`
    align-items: center;
    flex-wrap: nowrap;
    column-gap: 2px;
    width: auto;
    padding: 6px 12px;
    background: ${COLORS.BgMain};
    border-radius: 30px;
`;

export const Btn = styled.img<{isHide?: boolean}>`
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: ${p => p.isHide ? '0.2' : '1'};
    pointer-events: ${p => p.isHide ? 'none' : 'inherit'};
`;

export const CountValue = styled.div`
    min-width: 20px;
    justify-content: center;
    ${FONTS.S};
    color: ${COLORS.TextPrimary};
`;
